<template>
  <v-container class="limited">
    <dados-beneficiario></dados-beneficiario>
    <protocolo-detalhe
      v-if="isDetalhe"
      :numero-protocolo="numeroProtocolo"
      @voltar="voltar"
    ></protocolo-detalhe>
    <protocolo-grid v-else @detalhar="detalhar"></protocolo-grid>
  </v-container>
</template>

<script>
import DadosBeneficiario from "@/components/BeneficiaryData";

import ProtocoloDetalhe from "./protocolo-detalhe";
import ProtocoloGrid from "./protocolo-grid";

export default {
  name: "Protocolo",
  components: {
    DadosBeneficiario,
    ProtocoloDetalhe,
    ProtocoloGrid
  },
  data() {
    return {
      numeroProtocolo: null,
      isDetalhe: false
    };
  },
  methods: {
    detalhar(numeroProtocolo) {
      this.numeroProtocolo = numeroProtocolo;
      this.isDetalhe = true;
    },
    voltar() {
      this.numeroProtocolo = null;
      this.isDetalhe = false;
    }
  }
};
</script>
